<template>
  <div id="app">
    <userShareVideo></userShareVideo>
  </div>
</template>

<script>
  /**
   * import common css
   */
  require('./assets/styles/uservideo.less')
  import userShareVideo from './components/userShareVideo'
  export default {
    name: 'app',
    components: {
      userShareVideo,
    }
  }
</script>



// WEBPACK FOOTER //
// ShareVideo.vue?515139c6